import { Component, Injectable, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { UserService } from 'src/app/services/user.service';
import { DeviceService } from 'src/app/services/device.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';

@Component({
  selector: 'app-dispositivos',
  templateUrl: './dispositivos.component.html',
  styleUrls: ['./dispositivos.component.css'],
})
export class DispositivosComponent implements OnChanges{

  devicesAndEstablishmentInfo: any[] = []; //Información completa de los dispositivos y establecimientos
  devicesReferences: string = ""; //String con los dispositivos de los que necesitamos información
  nDispositivos: number = 0; //Número de dispositivos que el usuario puede visualizar
  datosRecibidos: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  errorMessage : string =""; //Mensaje de error
  displayedColumns: string[] = ['dev_reference', 'dev_label', 'establecimiento', 'razon_social', 'dev_serie', 'dev_sim', 'estado', 'dev_create_at', 'operaciones'];
  dataSource :any;
  pageSizeOptions: number[] = [10, 25, this.nDispositivos];
  clientsData: any = [];
  devicesData: any = [];
  userDataInfo: any = [];
  establecimientoData: any = [];

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  @Input() userData: any;

  private dispositivosSubscription: Subscription | undefined;
  private clientesSubscription: Subscription | undefined;
  private establecimientoSubscription: Subscription | undefined;

  constructor(private deviceService: DeviceService, private userService: UserService, private error429: Error429Service,
  private userDataService: UserDataService){
    this.userDataInfo = this.userDataService.getUserData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userData'] && this.userData !== undefined && this.userData.length !== 0) {
      if(this.userDataInfo.pro_id != "4"){
        this.displayedColumns = ['dev_reference', 'dev_label', 'establecimiento', 'dev_serie', 'dev_sim', 'estado', 'dev_create_at', 'operaciones'];
      }
      this.dispositivosSubscription = this.deviceService.getDevicesDataNew().subscribe({
        next:resp =>{
          this.devicesData = resp;
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () =>{
          this.clientesSubscription = this.userService.getClients().subscribe({
            next:resp =>{
              this.clientsData = resp;
            }, error: err => {
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
            },complete: () =>{
              this.establecimientoSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
                next: resp =>{
                  this.establecimientoData = resp;
                }, error: err => {
                  if (err.status == 429) {
                    this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                    this.recargarPaginaDespuesDeTiempo();
                  } else {
                    this.errorMessage = err.error.message;
                  }
                }, complete: () => {
                  for(let i=0; i<this.devicesData.length; i++){
                    let estado;
                    if(this.devicesData[i].dev_status == 1){
                      estado = "Activado";
                    } else {
                      if (this.devicesData[i].dev_status == 0){
                        estado = "Desactivado"
                      } else {
                        estado = "Desconocido"
                      }
                    }
                    const dispositivoInfo : any = {
                      id: this.devicesData[i].id,
                      est_id: this.devicesData[i].dev_est_id,
                      dev_reference: this.devicesData[i].dev_reference,
                      dev_label: this.devicesData[i].dev_label,
                      establecimiento: this.obtenerNombreEstablecimiento(this.devicesData[i].dev_est_id),
                      razon_social: this.obtenerNombreCliente(this.devicesData[i].dev_cliente_id),
                      dev_serie: this.devicesData[i].dev_serie,
                      dev_sim: this.devicesData[i].dev_sim,
                      estado: estado,
                      dev_create_at: this.devicesData[i].dev_create_at
                    };
                    this.devicesAndEstablishmentInfo.push(dispositivoInfo);
                  }
                  this.dataSource = new MatTableDataSource(this.devicesAndEstablishmentInfo);
                  this.dataSource.filterPredicate = (data: any, filter: string) => {
                    const dataStr = this.displayedColumns
                      .filter(key => key !== 'id' && key !== 'est_id')
                      .map(key => data[key])
                      .join('')
                      .toLowerCase();
                
                    return dataStr.includes(filter);
                  };
                  setTimeout(() => {
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;
                  }, 0);
                  this.datosRecibidos = true;
                }
              });
            }
          })
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.dispositivosSubscription) {
      this.dispositivosSubscription.unsubscribe();
    } 
    if (this.clientesSubscription) {
      this.clientesSubscription.unsubscribe();
    } 
    if (this.establecimientoSubscription) {
      this.establecimientoSubscription.unsubscribe();
    } 
  }
  
  obtenerNombreEstablecimiento(id: number){
    const establecimiento = this.establecimientoData.find((establecimiento:any) => establecimiento && establecimiento.id === id);
    return establecimiento ? establecimiento.est_name : 'Establecimiento no encontrado';
  }

  obtenerNombreCliente(id: number): string {
    const cliente = this.clientsData.find((cliente:any) => cliente && cliente.id === id);
    return cliente ? cliente.razon_social : 'Cliente no encontrada';
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  //Función para descargar la tabla en Excel
  descargarExcel(): void {
    // Crear un nuevo libro de Excel
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    // Definir las columnas en el archivo de Excel
    worksheet.columns = [
      { header: 'Referencia', key: 'dev_reference', width: 15 },
      { header: 'Nombre', key: 'dev_label', width: 25 },
      { header: 'Establecimiento', key: 'establecimiento', width: 25 },
      { header: 'Nº Serie', key: 'dev_serie', width: 25 },
      { header: 'Nº SIM', key: 'dev_sim', width: 35 },
      { header: 'Estado', key: 'estado', width: 30 },
      { header: 'Fecha de Alta', key: 'dev_create_at', width: 25 }
    ];

    // Agregar los datos a las filas del archivo de Excel
    this.devicesAndEstablishmentInfo.forEach(device => {
      worksheet.addRow(device);
    });

    // Generar el archivo de Excel en formato Buffer
    workbook.xlsx.writeBuffer().then(buffer => {
      // Crear un Blob a partir del Buffer
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Descargar el archivo utilizando la librería FileSaver.js
      saveAs(blob, 'Listado dispositivos DataBeer.xlsx');
    });
  }

}
